if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (button) {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
          }
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // Detectar si ya hay una imagen activa antes de ocultarlas
const activeImage = this.elements.viewer.querySelector('.is-active');

this.preHideImages(); 

setTimeout(() => {
  this.hideExtraImages();

  // Mantener la imagen activa para evitar parpadeo
  if (activeImage) {
    activeImage.style.display = 'block';
    activeImage.style.opacity = '1';
    activeImage.classList.add('is-active');
  }
}, 100);
        this.observeVariantChanges();
      }

      onSlideChanged(event) {
        if (!event.detail || !event.detail.currentElement) {
          console.warn("⚠️ Advertencia: No se pudo obtener la imagen actual en la galería.");
          return;
        }

        const currentElement = event.detail.currentElement;
        const mediaId = currentElement.dataset?.mediaId;

        if (!mediaId) {
          console.warn("⚠️ Advertencia: El elemento actual no tiene un 'mediaId'.");
          return;
        }

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          element.style.display = 'none';
          element.style.opacity = '0';
        });

        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('is-active');
        activeMedia.style.display = 'block';
        activeMedia.style.opacity = '1';

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.removeAttribute('aria-current');
        });
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      preHideImages() {
        const images = this.elements.viewer.querySelectorAll('[data-media-id]');
        images.forEach((image) => {
          image.style.opacity = '0';
          image.style.transition = 'opacity 0.2s ease-in-out';
        });
      }

      hideExtraImages() {
        const images = this.elements.viewer.querySelectorAll('[data-media-id]');
        let firstImage = null;

        images.forEach((image, index) => {
          if (index === 0) {
            image.classList.add('is-active');
            image.style.display = 'block';
            image.style.opacity = '1';
            firstImage = image;
          } else {
            image.classList.remove('is-active');
            image.style.display = 'none';
            image.style.opacity = '0';
          }
        });

        if (!firstImage && images.length > 0) {
          images[0].classList.add('is-active');
          images[0].style.display = 'block';
          images[0].style.opacity = '1';
        }
      }

      observeVariantChanges() {
        const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
        variantSelectors.forEach((selector) => {
          selector.addEventListener('change', () => {
            this.preHideImages();
            setTimeout(() => {
              this.hideExtraImages();
            }, 500);
          });
        });
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector('media-gallery');
  if (gallery) {
    gallery.preHideImages();
    setTimeout(() => {
      gallery.hideExtraImages();
    }, 500);
  }
});
